import { Action } from '@ngrx/store';
import { IMobileDevice } from '@app/certificates/devices/devices';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';

export const deviceKey = 'DEVICES';

export enum DevicesActionTypes {
    INITIALIZE = '[Devices] Initialize',
    ERROR = '[Devices] Error',
    DELETE = '[Devices] Delete',
    DELETE_SUCCESS = '[Devices] Delete success',
    ADD = '[Devices] Add device',
    ADD_SUCCESS = '[Devices] Add device success',
    REMOVE_DEVICE_FROM_CERTIFICATE = '[Devices] Remove device from certificate',
    UPDATE_CERTIFICATE_IDS_FOR_DEVICE = '[Devices] Update certificate ids for device',
    CLEAR_DEVICES = '[Devices] Clear Devices'
}

export class ActionDevicesInitialize implements Action {
    readonly type = DevicesActionTypes.INITIALIZE;
    constructor(public payload: { devices: IMobileDevice[] }) { }
}

export class ActionDevicesError implements Action {
    readonly type = DevicesActionTypes.ERROR;
    constructor(public payload: { response?: ISpringResponseBody }) { }
}

export class ActionDevicesDelete implements Action {
    readonly type = DevicesActionTypes.DELETE;
    constructor(public payload: { deviceId: string }) { }
}
export class ActionRemoveDeviceFromCertificatе implements Action {
    readonly type = DevicesActionTypes.REMOVE_DEVICE_FROM_CERTIFICATE;
    constructor(public payload: { deviceId: string, certReqId: string }) { }
}

export class ActionUpdateCertificatеsForDevice implements Action {
  readonly type = DevicesActionTypes.UPDATE_CERTIFICATE_IDS_FOR_DEVICE;
  constructor(public payload: { deviceId: string, certReqId: string }) { }
}

export class ActionDevicesDeleteSuccess implements Action {
    readonly type = DevicesActionTypes.DELETE_SUCCESS;
    constructor(public payload: { devices: IMobileDevice[], deletedDeviceId: string, certReqId: string }) { }
}
export class ActionDevicesAdd implements Action {
    readonly type = DevicesActionTypes.ADD;
    constructor(public payload: { devices: IMobileDevice[] }) { }
}

export class ActionDevicesAddSuccess implements Action {
    readonly type = DevicesActionTypes.ADD_SUCCESS;
    constructor(public payload: { devices: IMobileDevice[] }) { }
}

export class ActionDevicesClearDevices implements Action {
    readonly type = DevicesActionTypes.CLEAR_DEVICES;
}

export type ManageDeviceActions =
    ActionDevicesInitialize |
    ActionDevicesError |
    ActionDevicesDeleteSuccess |
    ActionRemoveDeviceFromCertificatе |
    ActionDevicesAddSuccess |
    ActionUpdateCertificatеsForDevice |
    ActionDevicesClearDevices;

export const selectorDevice = state => state.devices as IMobileDevice[];

export function manageDeviceReducer(
    state: IMobileDevice[],
    action: ManageDeviceActions
): IMobileDevice[] {
    switch (action.type) {
        case DevicesActionTypes.UPDATE_CERTIFICATE_IDS_FOR_DEVICE:
            return updateCertificateIds(state,action.payload);
        case DevicesActionTypes.INITIALIZE:
        case DevicesActionTypes.DELETE_SUCCESS:
        case DevicesActionTypes.ADD_SUCCESS:
            return action.payload.devices;
        case DevicesActionTypes.ERROR:
        case DevicesActionTypes.CLEAR_DEVICES:
            return [];
        default:
            return state;
    }
}

export interface IDeviceSate {
    devices: IMobileDevice[];
}

function updateCertificateIds(devices: IMobileDevice[], payload: { deviceId: string, certReqId: string }){
  const updateDevices: IMobileDevice[] = JSON.parse(JSON.stringify(devices));
  let deviceUpdated = false;

  updateDevices.forEach(device => {
       if(device.appId === payload.deviceId){
          deviceUpdated=true;
          device.certificateReqIds = device.certificateReqIds.filter(certificateRequestId => certificateRequestId !== payload.certReqId);
       }
  });

  if(deviceUpdated){
    return updateDevices;
  }
  return devices;
}
